import React from 'react';
import { DialogActions, Dialog, DialogTitle, DialogContent, DialogContentText } from "@material-ui/core";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import { Error as ErrorIcon, Info as InfoIcon, Warning as WarningIcon } from "@material-ui/icons";

// Field name mapping for user-friendly display
const FIELD_NAME_MAPPING = {
    // Basic Project Information
    'ProjectName': 'Project Name',
    'WBSEcode': 'WBSE Code',
    'SecondaryPOC': 'Client Project Requester Email ID', // In PlainInstance full config, this is Client Project Requester Email ID
    'PrimaryPoc': 'Primary Point of Contact',
    'DataClassification': 'Data Classification',
    'TeamName': 'Team Name',
    'RequestNotes': 'Request Notes',
    'TeamNameOthers': 'Team Name (Other)',

    // Contract & Client Information
    'SAPContractID': 'SAP Contract ID',
    'ContractId': 'Contract ID',
    'ClientName': 'Client Name',
    'ClientNameInternal': 'Internal Client Name',
    'Pocdetails': 'Point of Contact Details',
    'ContractAvailabilityDate': 'Contract Availability Date',
    'ContractDeliveryLeadEid': 'Contract Delivery Lead EID',
    'Company': 'Company',
    'AvanadeCountry': 'Avanade Country',
    'AccentureCountry': 'Accenture Country',
    'EndToEndUId': 'End to End UID',
    'RITM': 'RITM',

    // Dedicated Virtual Network Setup fields
    'DeliveryLead': 'Delivery Lead',
    'DeploymentLead': 'Deployment Lead',
    'DeploymentPhase': 'Deployment Phase',
    'LLMProvider': 'LLM Provider',
    'ConnectivityType': 'Connectivity Type',
    'CloudPlatform': 'Cloud Platform',
    'AppList': 'Applications To Provision',

    // Alternative field names that might be used in different forms
    'POCdetails': 'Point of Contact Details',
    'PocDetails': 'Point of Contact Details',
    'ClientNamePlatformInternal': 'Internal Client Name',

    // Environment & Deployment
    'DeploymentRegion': 'Deployment Region',
    'DomainContextRoot': 'Domain Context Root',
    'Environment': 'Environment',
    'InstanceType': 'Instance Type',
    'Tier': 'Service Tier',
    'PaymentRate': 'Payment Rate',

    // Service Configuration
    'TentativeServiceEndDate': 'Service End Date',
    'ServiceEndDate': 'Service End Date',
    'AdminDistributionGroup': 'Admin Distribution Group',
    'SuperAdminDistributionGroup': 'Super Admin Distribution Group',
    'UsersDistributionGroup': 'Users Distribution Group',
    'UserManagementGroup': 'User Management Group',

    // Volume & Performance
    'DailyDataVolume': 'Daily Data Volume',
    'ConcurrentUsers': 'Concurrent Users',
    'BenefitsExpected': 'Benefits Expected',
    'MonthlyTicketVolume': 'Monthly Ticket Volume',
    'TicketMonthlyVolume': 'Monthly Ticket Volume',
    'TicketFeed': 'Ticket Feed Method',
    'TAapps': 'Configure Splunk Application',

    // AI & Integration Configuration
    'ChatGPT': 'ChatGPT Configuration',
    'OpenAI': 'OpenAI Configuration',
    'OpenAITextEmbeddingsModel': 'OpenAI Text Embeddings Model',
    'DialogFlow': 'DialogFlow Configuration',
    'DialogFlowDevToken': 'DialogFlow Developer Token',
    'DialogFlowClientToken': 'DialogFlow Client Token',
    'GDPR': 'GDPR Compliance',
    'AAAMTermsConditions': 'AAAM Terms & Conditions',

    // Model & Platform Configuration
    'modelname': 'Model Name',
    'VendorName': 'Vendor Name',
    'ConfigurationType': 'Configuration Type',
    'AaamPlatformType': 'Platform Type',

    // GenWizard Specific
    'Genwizard_Core': 'GenWizard Core Components',
    'Genwizard_Agent_Module': 'GenWizard Agent Modules',
    'EnableMultisource': 'Enable Multisource',
    'QppVersion': 'QPP Version',

    // Special validation messages
    'Genwizard Core selection': 'GenWizard Core Applications',
    'Agent Module selection (required when AD is selected)': 'Agent Module Selection',

    // Apps and Integrations
    'Quasarpp': 'Quasar++',
    'AD': 'Application Development',
    'ATR': 'Automated Testing & Reporting',
    'CUI': 'Conversational UI',
    'IAM': 'Identity & Access Management',
    'KM': 'Knowledge Management',
    'AM': 'Agent Manager',
    'UTKM': 'Steward (UTKM)',

    // Additional Fields
    'CustomURL': 'Custom URL',
    'DNS': 'DNS Configuration',
    'SecondaryCustomerID': 'Secondary Customer ID',
    'CustomerEnterpriseID': 'Customer Enterprise ID',
    'DMSId': 'DMS ID',
    'InstanceId': 'Instance ID',
    'DeployRegion': 'Deploy Region',

    // Conditional Fields (when no SAP Contract ID)
    'Pocdetails': 'Contract Delivery Lead EID',
    'POCdetails': 'Contract Delivery Lead EID',
    'PocDetails': 'Contract Delivery Lead EID',
    'ContractDeliveryLeadEid': 'Contract Delivery Lead EID',
    'ContractDeliveryLeadEID': 'Contract Delivery Lead EID',
    'ContractDeliveryLeadEId': 'Contract Delivery Lead EID',
    'OpportunityID': 'Opportunity ID',
    'OpportunityId': 'Opportunity ID',

    // Alternative field name variations
    'SecondaryPoc': 'Client Project Requester Email ID',
    'PrimaryPOC': 'Primary Point of Contact',
    'primary_poc': 'Primary Point of Contact',
    'secondary_poc': 'Client Project Requester Email ID',
    'ClientProjectRequesterEmailID': 'Client Project Requester Email ID',
    'ClientProjectRequesterEmailId': 'Client Project Requester Email ID',
    
    //genwizard agent
    'BR_Endpoint' : 'Bedrock Endpoint',
    'BR_Arn' : 'Bedrock ARN',
    'BR_Region' : 'Bedrock Region',
    'BR_AccessId' : 'Bedrock Access ID',
    'BR_AccessKey' : 'Bedrock Acccess Key',
    'BR_Model' : 'Bedrock Model',
    

    // Error type suffixes
    ' (invalid format)': ' - Invalid Format',
    ' (invalid value)': ' - Invalid Value',
    ' (invalid date)': ' - Invalid Date',
    ' (must be 10 digits)': ' - Must be 10 digits',
    ' (client validation failed)': ' - Client validation failed',
    ' (must be 1-200)': ' - Must be between 1-200',
    ' (must be between 1-9)': ' - Must be between 1-9',
    ' (required when AD is selected)': ' - Required when Application Development is selected'
};

// Step mapping for better navigation (default mapping for forms)
const FIELD_STEP_MAPPING = {
    // Step 1: Client & Contract Information
    'ProjectName': 'Step 1',
    'WBSEcode': 'Step 1',
    'SecondaryPOC': 'Step 1',
    'PrimaryPoc': 'Step 1',
    'DataClassification': 'Step 1',
    'TeamName': 'Step 1',
    'TeamNameOthers': 'Step 1',
    'RequestNotes': 'Step 1',
    'SAPContractID': 'Step 1',
    'ContractId': 'Step 1',
    'Pocdetails': 'Step 1',
    'ClientName': 'Step 1',
    'ClientNameInternal': 'Step 1',
    'ContractAvailabilityDate': 'Step 1',
    'ContractDeliveryLeadEid': 'Step 1',
    'Company': 'Step 1',
    'AvanadeCountry': 'Step 1',
    'AccentureCountry': 'Step 1',
    'EndToEndUId': 'Step 1',
    'RITM': 'Step 1',
    'DeploymentPhase': 'Step 1',

    // Conditional fields when no SAP Contract ID
    'POCdetails': 'Step 1',
    'PocDetails': 'Step 1',
    'OpportunityID': 'Step 1',
    'OpportunityId': 'Step 1',
    'ContractDeliveryLeadEID': 'Step 1',
    'ContractDeliveryLeadEId': 'Step 1',

    // Alternative field name variations
    'SecondaryPoc': 'Step 1',
    'PrimaryPOC': 'Step 1',
    'primary_poc': 'Step 1',
    'secondary_poc': 'Step 1',
    'ClientNamePlatformInternal': 'Step 1',

    // Step 2: Environment Details
    'DeploymentRegion': 'Step 2',
    'DomainContextRoot': 'Step 2',
    'Environment': 'Step 2',
    'Tier': 'Step 2',
    'PaymentRate': 'Step 2',
    'DailyDataVolume': 'Step 2',
    'GDPR': 'Step 2',
    'CustomURL': 'Step 2',
    'DNS': 'Step 2',

    // Step 3: Application Configuration
    'AdminDistributionGroup': 'Step 3',
    'SuperAdminDistributionGroup': 'Step 3',
    'UsersDistributionGroup': 'Step 3',
    'UserManagementGroup': 'Step 3',
    'TentativeServiceEndDate': 'Step 3',
    'ServiceEndDate': 'Step 3',
    'ConcurrentUsers': 'Step 3',
    'BenefitsExpected': 'Step 3',
    'MonthlyTicketVolume': 'Step 3',
    'ChatGPT': 'Step 3',
    'OpenAI': 'Step 3',
    'OpenAITextEmbeddingsModel': 'Step 3',
    'DialogFlow': 'Step 3',
    'DialogFlowDevToken': 'Step 3',
    'DialogFlowClientToken': 'Step 3',
    'AAAMTermsConditions': 'Step 3',
    'modelname': 'Step 3',
    'Genwizard_Core': 'Step 3',
    'Genwizard_Agent_Module': 'Step 3',
    'Genwizard Core selection': 'Step 3',
    'Agent Module selection (required when AD is selected)': 'Step 3',
    'EnableMultisource': 'Step 3',
    'QppVersion': 'Step 3',
    'Quasarpp': 'Step 3',
    'AD': 'Step 3',
    'ATR': 'Step 3',

    // Genwizard Agent fields (Step 3)
    'CUI': 'Step 3',
    'IAM': 'Step 3',
    'KM': 'Step 3',
    'AM': 'Step 3',
    'UTKM': 'Step 3',
    'JIRA_ProjectKey': 'Step3',
    'JIRA_Endpoint': 'Step3',
    'JIRA_Username': 'Step3',
    'JIRA_Password': 'Step3',

    // Automation Anywhere License fields (Step 3)
    'LicenseUsage': 'Step 3',
    'AAversion': 'Step 3',
    'NumOfControlRoomlicenses': 'Step 3',
    'NumOfDeveloperlicenses': 'Step 3',
    'NumOfRunnerlicenses': 'Step 3',
    'InstanceName': 'Step 3',
    'InstanceType': 'Step 3',

    // Ticket Analysis fields (Step 3)
    'TicketFeed': 'Step 3',
    'TicketMonthlyVolume': 'Step 3',
    'AdminDistributionGroup': 'Step 3',
    'UsersDistributionGroup': 'Step 3',
    'TAapps': 'Step 3',

    // On-Premise Service fields
    'InfrastructureType': 'Step 2',
    'LicensePurpose': 'Step 3',
    'AiOpsAsset': 'Step 3',
    'Custom': 'Step 3',

    // Generic license fields that might appear in multiple forms
    'Runnerlicenses': 'Step 3',
    'Controllicenses': 'Step 3',
    'Developerlicenses': 'Step 3'
};

// Function to get user-friendly field name
const getUserFriendlyFieldName = (fieldName, customFieldLabels = null) => {
    // Priority 1: Use custom field labels provided by the form
    if (customFieldLabels) {
        // Handle special cases with error descriptions
        for (const [key, value] of Object.entries(customFieldLabels)) {
            if (fieldName.includes(key)) {
                return fieldName.replace(key, value);
            }
        }

        // Direct mapping from custom labels
        if (customFieldLabels[fieldName]) {
            return customFieldLabels[fieldName];
        }
    }

    // Priority 2: Use default field mapping
    for (const [key, value] of Object.entries(FIELD_NAME_MAPPING)) {
        if (fieldName.includes(key)) {
            if(fieldName.indexOf('ADO') < 0)
                return fieldName.replace(key, value);
        }
    }

    if (FIELD_NAME_MAPPING[fieldName]) {
        return FIELD_NAME_MAPPING[fieldName];
    }

    // Priority 3: Fallback - Convert camelCase to Title Case
    if (fieldName.indexOf('ADO') >= 0 || fieldName.indexOf('JIRA') >= 0) {
        return fieldName
            .replace('_', ' ') // Add space before capital letters
            .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
            .trim();
    } else {
        return fieldName
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
            .trim();
    }
};

// Function to get field step
const getFieldStep = (fieldName) => {
    // Check direct mapping first
    if (FIELD_STEP_MAPPING[fieldName]) {
        return FIELD_STEP_MAPPING[fieldName];
    }

    // Check if fieldName contains any key from mapping
    for (const [key, step] of Object.entries(FIELD_STEP_MAPPING)) {
        if (fieldName.includes(key)) {
            return step;
        }
    }

    return null;
};

/**
 * Reusable Form Validation Dialog Component
 * Shows validation errors in a user-friendly modal format
 *
 * @param {boolean} open - Whether dialog is open
 * @param {function} onClose - Function to call when dialog closes
 * @param {array} errors - Array of validation error messages
 * @param {string} title - Dialog title (optional)
 * @param {string} buttonText - Action button text (optional)
 * @param {boolean} groupByStep - Whether to group errors by form step (optional)
 * @param {object} stepMapping - Custom step mapping for field names (optional)
 * @param {object} stepLabels - Custom step labels for this form (optional)
 * @param {object} fieldLabels - Custom field name mappings for this form (optional)
 * @param {boolean} showStepNumbers - Whether to show step numbers/badges (optional)
 * @param {boolean} showInstanceType - Whether to show InstanceType validation errors (optional, default false)
 */
const ValidationDialog = ({
    open,
    onClose,
    errors = [],
    title = "Complete Required Fields",
    buttonText = "CONTINUE",
    groupByStep = false, // Changed default to false for simpler usage
    stepMapping = null, // Custom step mapping for this form
    stepLabels = null,  // Custom step labels for this form
    fieldLabels = null, // Custom field labels for this form
    showStepNumbers = true, // Whether to show step numbers/badges (default true for backward compatibility)
    showInstanceType = false // Whether to show InstanceType validation errors (default false for backward compatibility)
}) => {
    // Use custom step mapping if provided, otherwise use default
    const getStepForField = (fieldName) => {
        if (stepMapping) {
            // Check direct mapping first
            if (stepMapping[fieldName]) {
                return stepMapping[fieldName];
            }
            // Check if fieldName contains any key from custom mapping
            for (const [key, step] of Object.entries(stepMapping)) {
                if (fieldName.includes(key)) {
                    return step;
                }
            }
        }
        // Fallback to default mapping
        return getFieldStep(fieldName) || 'Other';
    };

    // Filter out fields that shouldn't be shown to users (like auto-set fields)
    const filteredErrors = errors.filter(error => {
        // Hide InstanceType unless explicitly requested to show it
        if (error.includes('InstanceType')) {
            return showInstanceType;
        }
        return true;
    });

    // Group errors by step for better organization
    const groupedErrors = groupByStep ? filteredErrors.reduce((groups, error) => {
        const step = getStepForField(error);
        if (!groups[step]) groups[step] = [];
        groups[step].push(error);
        return groups;
    }, {}) : null;
    return (
        <Dialog open={open} onClose={onClose} fullWidth={false}>
            <DialogTitle
                style={{
                    backgroundColor: "#7500C0",
                    color: '#FFFFFF',
                    height: '50px',
                    padding: '5px 20px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent style={{ overflowY: "unset", width: '450px' }}>
                <DialogContentText style={{ fontSize: '.9em', color: "#666666", fontWeight: "400" }}>
                    <div style={{ fontFamily: 'Graphik, sans-serif', padding: '20px 0' }}>
                        {/* Simple header message */}
                        <div style={{
                            marginBottom: '20px',
                            padding: '16px 20px',
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffeaa7',
                            borderRadius: '4px',
                            color: '#856404',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <span style={{ fontWeight: '600', color: '#b8860b' }}>
                                {filteredErrors.length} required fields need attention:
                            </span>
                        </div>

                        {/* Compact error list */}
                        <div style={{
                            maxHeight: '250px',
                            overflowY: 'auto',
                            marginBottom: '20px',
                            padding: '0 4px'
                        }}>
                            {groupByStep && groupedErrors ? (
                                // Grouped view - more compact, sorted by step order
                                Object.entries(groupedErrors)
                                    .sort(([stepA], [stepB]) => {
                                        // Sort steps in order: Step 1, Step 2, Step 3, Other, then alphabetically
                                        const stepOrder = { 'Step 1': 1, 'Step 2': 2, 'Step 3': 3, 'Other': 99 };
                                        const aOrder = stepOrder[stepA] || 50;
                                        const bOrder = stepOrder[stepB] || 50;

                                        if (aOrder !== bOrder) {
                                            return aOrder - bOrder;
                                        }

                                        // If same order, sort alphabetically
                                        return stepA.localeCompare(stepB);
                                    })
                                    .map(([step, stepErrors]) => (
                                        <div key={step} style={{ marginBottom: '16px' }}>
                                            <div style={{
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#7500C0',
                                                marginBottom: '8px',
                                                padding: '4px 8px',
                                                backgroundColor: '#f8f9fa',
                                                borderLeft: '3px solid #7500C0',
                                                borderRadius: '2px'
                                            }}>
                                                {stepLabels && stepLabels[step] ? stepLabels[step] :
                                                    step === 'Step 1' ? 'Step 1: Client & Contract' :
                                                        step === 'Step 2' ? 'Step 2: Environment' :
                                                            step === 'Step 3' ? 'Step 3: Application' :
                                                                step
                                                }
                                            </div>
                                            <ul style={{ listStyleType: 'none', padding: '0', margin: '0 0 0 12px' }}>
                                                {stepErrors.map((error, index) => {
                                                    const friendlyName = getUserFriendlyFieldName(error, fieldLabels);
                                                    return (
                                                        <li key={index} style={{
                                                            padding: '6px 12px',
                                                            margin: '4px 0',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #dee2e6',
                                                            borderLeft: '3px solid #dc3545',
                                                            borderRadius: '3px',
                                                            fontSize: '13px',
                                                            color: '#333',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}>
                                                            <ErrorIcon style={{ marginRight: '8px', fontSize: '16px', color: '#dc3545' }} />
                                                            <span>
                                                                {friendlyName.split(' - ')[0]}
                                                                {friendlyName.includes(' - ') && (
                                                                    <em style={{ color: '#666', fontSize: '12px' }}>
                                                                        {' - ' + friendlyName.split(' - ')[1]}
                                                                    </em>
                                                                )}
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    ))
                            ) : (
                                // Simple list view - sorted by step order
                                <ul style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                                    {filteredErrors
                                        .map(error => ({
                                            error,
                                            friendlyName: getUserFriendlyFieldName(error, fieldLabels),
                                            step: getStepForField(error)
                                        }))
                                        .sort((a, b) => {
                                            // Sort by step order (Step 1, Step 2, Step 3, Other, then alphabetically)
                                            const stepOrder = { 'Step 1': 1, 'Step 2': 2, 'Step 3': 3, 'Other': 99 };
                                            const aOrder = stepOrder[a.step] || 50;
                                            const bOrder = stepOrder[b.step] || 50;

                                            if (aOrder !== bOrder) {
                                                return aOrder - bOrder;
                                            }

                                            // If same step, sort alphabetically by friendly name
                                            return a.friendlyName.localeCompare(b.friendlyName);
                                        })
                                        .map(({ error, friendlyName, step }, index) => (
                                            <li key={index} style={{
                                                padding: '8px 12px',
                                                margin: '4px 0',
                                                backgroundColor: '#fff',
                                                border: '1px solid #dee2e6',
                                                borderLeft: '3px solid #dc3545',
                                                borderRadius: '3px',
                                                fontSize: '13px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ color: '#333' }}>
                                                        {friendlyName.split(' - ')[0]}
                                                        {friendlyName.includes(' - ') && (
                                                            <em style={{ color: '#666', fontSize: '12px' }}>
                                                                {' - ' + friendlyName.split(' - ')[1]}
                                                            </em>
                                                        )}
                                                    </span>
                                                </div>
                                                {step && showStepNumbers && (
                                                    <span style={{
                                                        fontSize: '11px',
                                                        backgroundColor: '#7500C0',
                                                        color: 'white',
                                                        padding: '2px 6px',
                                                        borderRadius: '10px',
                                                        fontWeight: '500'
                                                    }}>
                                                        {step}
                                                    </span>
                                                )}
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>

                        {/* Info footer note */}
                        <div style={{
                            padding: '12px 16px',
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #bbdefb',
                            borderRadius: '4px',
                            fontSize: '12px',
                            color: '#1565c0',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <InfoIcon style={{ marginRight: '8px', fontSize: '16px', color: '#2196f3' }} />
                            <div>
                                <strong>Note:</strong> Fields with red borders require completion.{showStepNumbers ? ' Navigate between steps to fill all required fields.' : ' Scroll to locate and fill all required fields.'}
                            </div>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ padding: '16px 24px 20px 24px' }}>
                <AcceptButton2
                    onClick={onClose}
                    label={buttonText}
                />
            </DialogActions>
        </Dialog>
    );
};

export default ValidationDialog;